import React from "react";
import "../../stylesheets/_home.scss";
import IntroContainer from "../../components/IntroContainer";
import ApiContainer from "../../components/ApiContainer";
import Footer from "../../components/Footer";
import "../../stylesheets/screen.css.scss";

const Home = () => {
  return (
    <div className='home' data-testId="home-container">
      <div id="iframe_container">
        <IntroContainer />
        <ApiContainer />
        <Footer/>
      </div>
    </div>
  );
};

export default Home;
